import { Address, emptyAddress } from './address';

export type Location = Components.Schemas.Location;

export const emptyLocation = (): Location => ({
	id: '',
	locationId: '',
	companyId: '',
	addressId: '',
	name: '',
	address: emptyAddress(),
	active: true,
	pendingInstalls: 0,
});
